import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import Bookings from '../../Components/admin/Bookings';
import Orders from '../../Components/admin/Orders';
import Coupons from '../../Components/admin/CouponManager';
import Academy from '../../Components/admin/AcademyWaitlist';
import Login from '../../Components/admin/Login';
import Sidebar from '../../Components/admin/Sidebar';

const AdminDashboard = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('isAuthenticated') === 'true'
  );
  const [activeTab, setActiveTab] = useState('');
  const [isOpen, setIsOpen] = useState(false); // Start closed on mobile

  // Set initial sidebar state based on screen size
  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth >= 768);
    };
    // Set initial state
    handleResize();
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Update activeTab based on current path
  useEffect(() => {
    const path = window.location.pathname;
    const currentTab = path.split('/').pop();
    setActiveTab(currentTab);
  }, []);

  if (!isAuthenticated) {
    return <Login setIsAuthenticated={setIsAuthenticated} />;
  }

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* Sidebar */}
      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        isOpen={isOpen} 
        setIsOpen={setIsOpen}
      />

      {/* Main Content */}
      <div 
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300
          ${isOpen ? 'md:ml-40' : 'md:ml-16'} 
          ${isOpen ? '' : 'ml-0'}
        `}
      >
        {/* Optional: Top bar for mobile */}
        <div className="md:hidden bg-white h-0 flex items-center px-4 shadow-sm">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="p-2 rounded-md hover:bg-gray-100"
          >
          </button>
        </div>

        {/* Main content area */}
        <main 
          className={`flex-1 overflow-y-auto bg-gray-100 p-4 md:p-6
            ${isOpen && window.innerWidth < 768 ? 'blur-sm' : ''}`}
          onClick={() => {
            if (isOpen && window.innerWidth < 768) {
              setIsOpen(false);
            }
          }}
        >
          <div className="max-w-7xl mx-auto">
            <Routes>
              <Route path="bookings" element={<Bookings />} />
              <Route path="orders" element={<Orders />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="academy" element={<Academy />} />
              <Route path="/" element={<Navigate to="/admin/bookings" replace />} />
            </Routes>
          </div>
        </main>
      </div>

      {/* Overlay for mobile when sidebar is open */}
      {isOpen && window.innerWidth < 768 && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminDashboard;